import { render } from "./TwelveHeader.vue?vue&type=template&id=0a064c94"
import script from "./TwelveHeader.vue?vue&type=script&lang=js"
export * from "./TwelveHeader.vue?vue&type=script&lang=js"

import "./TwelveHeader.vue?vue&type=style&index=0&id=0a064c94&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__